export default __webpack_public_path__ + "assets/webgl/illuminators.655f8af1.gltf";